import { EntityStateModel } from 'app/projects/entity/src/lib/models/entity.state-model';
import { CourseRelevantExecution } from './course-relevant-execution.model';

export class CourseRelevantExecutionStateModel extends EntityStateModel<CourseRelevantExecution> {}
